export default "__VITE_ASSET__2bf870a4__"